import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=212632e3&scoped=true&"
import script from "./StatisticsTable.vue?vue&type=script&lang=js&"
export * from "./StatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTable.vue?vue&type=style&index=0&id=212632e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212632e3",
  null
  
)

export default component.exports